module.exports = __webpack_public_path__ + "img/paso_1.b7cf3e82.png";